export default __webpack_public_path__ + "static/media/pin.a4f5538c.svg";